import BaseModel from './base-model';
/**
 * format:
 * @COMMON_NAME: "DESARROLLO SOFTWARE SERVICIOS HORIZONTALES (ACCENTURE)"
 * @REL_ATTR: "U'3C05152D54C901DE99E8001CC416E56E'"
 * @id: "U'3C05152D54C901DE99E8001CC416E56E'"
 */
export default class Organization extends BaseModel {
  constructor(opts = {}) {
    super(opts);
  }
}
